export enum BillingRateType {
    BOTH = 0,
    TRAVEL = 1,
    PERDIEM = 2
}
